export function getSubdomain(hostname) {
    const parts = hostname.split(".");
    if (parts.length > 2) {
        return { subdomain: parts[0] };
    }
    // else if(hostname.includes('localhost')){
    //     return {subdomain: 'app'}
    // }
    return { subdomain: "app" }; // Return empty if no subdomain is present
}
